/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */
export default function slateRte() {

	slate.rte = {
		/**
		 * Wrap tables in a container div to make them scrollable when needed
		 *
		 * @param {object} options - Options to be used
		 * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
		 * @param {string} options.tableWrapperClass - table wrapper class name
		 */
		wrapTable: function(options) {
			var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

			options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
		},

		/**
		 * Wrap iframes in a container div to make them responsive
		 *
		 * @param {object} options - Options to be used
		 * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
		 * @param {string} options.iframeWrapperClass - class name used on the wrapping div
		 */
		wrapIframe: function(options) {
			var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass,
			iframeWrapperClassInner = typeof options.iframeWrapperClassInner === "undefined" ? '' : options.iframeWrapperClassInner;

			options.$iframes.each(function() {
				var $this = $(this),
				aspectRatio = this.height / this.width;

				// Add wrapper to make video responsive
				$this.wrap('<div class="' + iframeWrapperClass + '"><div class="' + iframeWrapperClassInner + '"></div></div>');

				if(aspectRatio !== 0.5625) {
					$this.parent().css('padding-bottom', aspectRatio * 100 + '%');
				}
				
				// Re-set the src attribute on each iframe after page load
				// for Chrome's "incorrect iFrame content on 'back'" bug.
				// https://code.google.com/p/chromium/issues/detail?id=395791
				// Need to specifically target video and admin bar
				this.src = this.src;
			});
		}
	};
}
